import React, { useState } from 'react'
import { JsonToTable } from 'react-json-to-table'
import { connect } from 'react-redux'
import { getCurrentContextuserIdDetails } from '../api/components-examples/Admin/AccountUtility'
import '../api/components-examples/Admin/admin.css'
import PopUP from '../api/components-examples/PopUP'
import { Loading } from '../api/components-examples/utils'
import GenericMsgErrorBoundary from '../api/components-examples/utils/ErrorBoundary/GenericMsgErrorBoundary'
import { setProjectInfoKey } from '../api/redux/FrameWorkReducer'
import { addNotification } from '../api/redux/notificationAction'
import { BuildFlowIcon, LearnFLowIcon, vizardIcon, noteBookIcon, appsIcon, datasetsIcon, homeIcon, projectsIcon, defaultIcon } from '../UI-components/SvgIcons/Icons'
import WaitingLoaders from '../UI-components/Loaders/WaitingLoaders'

const NewVerticalNavigation = ({
  items,
  history,
  myTemplates,
  myApps,
  theme,
  dataset,
  myProfile,
  activeItem,
  currentPath,
  checkUberDeployment,
  myUserAccountInfo,
  api,
  dispatch,
  buildInfo,
  userProjectPermissions,
  isSubscriptionCheck,
  noOrgs
}) => {
  // FIXME: Use Link from react router instead
  const [viewAbout, setViewAbout] = useState(false)
  const [versionInfo, setVersionInfo] = useState({ isLoading: true })
  const [isLoadingversionInfo, setIsLoadingversionInfo] = useState(false)

  const navigateTo = (path, params) => {
    history.push(path, params)
  }

  const curTheme = theme
  const totalapps = myApps.searchInfo.total
  const current_logged_user = getCurrentContextuserIdDetails(myUserAccountInfo.current_logged_user)

  const data = myTemplates


  const currentAvailedPlan =
    isSubscriptionCheck &&
      !isSubscriptionCheck.isLoading &&
      isSubscriptionCheck.subscribedProduct &&
      isSubscriptionCheck.subscribedProduct.name
      ? isSubscriptionCheck.subscribedProduct.name
      : 'NO_PLAN'

  const handleClickViewAbout = () => {
    setIsLoadingversionInfo(true)
    if (buildInfo && !buildInfo.isLoading && buildInfo.result) {
      setViewAbout(!viewAbout)
      setVersionInfo(buildInfo.result)
      setIsLoadingversionInfo(false)
      return
    }
    let current_logged_user = getCurrentContextuserIdDetails(myUserAccountInfo.current_logged_user)
    dispatch(api.createFetchVersionInfoRSAA(current_logged_user.orgId))
      .then(response => {
        const hasError = response.type.toLowerCase().endsWith('failure')
        if (!hasError) {
          if (response.payload) {
            setViewAbout(!viewAbout)
            setVersionInfo(response.payload.result)
          }
        } else {
          dispatch(
            addNotification(
              `${response.payload && response.payload.response && response.payload.response.message
                ? response.payload.response.message
                : 'We are unable to Process, Please try later'
              }`,
              'danger'
            )
          )
          setVersionInfo(response.payload.response)
        }
      })
      .then(() => {
        setIsLoadingversionInfo(false)
      })
  }

  return (
    <>
      {isLoadingversionInfo === true && <WaitingLoaders show={true} size={90} position='fixed' />}
      {viewAbout && (
        <div className="about-plaform">
          <PopUP
            width={'40%'}
            onCancel={() => setViewAbout(!viewAbout)}
            bottomButton={false}
            bottomButtonCancel={false}
          >
            {!versionInfo.isLoading ? (
              <GenericMsgErrorBoundary msg="Unable to show result in this format">
                <div className="admin-comp">
                  <JsonToTable json={versionInfo} />
                </div>
              </GenericMsgErrorBoundary>
            ) : (
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Loading />
              </div>
            )}
          </PopUP>
        </div>
      )}
      {myProfile &&
        isSubscriptionCheck &&
        !isSubscriptionCheck.isLoading && (
          <div data-theme={theme} className={`LeftSidePanel em-scroll`}>
            <>
              <div className="em-items">
                <TopNavigationItems
                  items={items}
                  activeItem={activeItem}
                  totalapps={totalapps}
                  data={data}
                  dataset={dataset}
                  history={history}
                  curTheme={curTheme}
                  currentPath={currentPath}
                  checkUberDeployment={checkUberDeployment}
                  current_logged_user={current_logged_user}
                  navigateTo={navigateTo}
                  dispatch={dispatch}
                  currentAvailedPlan={currentAvailedPlan}
                />

                {userProjectPermissions &&
                  !userProjectPermissions.isLoading &&
                  userProjectPermissions.space_create === true &&
                  <div className={"quick-flowLinks"}>
                    {currentAvailedPlan.toUpperCase() !== 'LEARNER' && <VerticalNavbarItem
                      checkUberDeployment={checkUberDeployment}
                      style={
                        currentPath ===
                          `/projects/flows/build`
                          ? 'nav-item selected'
                          : 'nav-item'
                      }
                      title={'Build Flows'}
                      link="/projects"
                      name={'buildFlows'}
                      index={1}
                      external={false}
                      navigateTo={e => {
                        e.preventDefault()
                        navigateTo({ pathname: `/projects/flows/build` })
                        dispatch(setProjectInfoKey(new Date().getTime()))
                      }}
                    />}
                    {currentAvailedPlan.toUpperCase() === 'LEARNER' &&
                      <VerticalNavbarItem
                        checkUberDeployment={checkUberDeployment}
                        style={
                          currentPath ===
                            `/projects/flows/learn`
                            ? 'nav-item selected'
                            : 'nav-item'
                        }
                        title={currentAvailedPlan.toUpperCase() === 'LEARNER' ? 'New Course' : 'Learn Flows'}
                        link="/projects"
                        name={'learnFlows'}
                        index={1}
                        external={false}
                        navigateTo={e => {
                          e.preventDefault()
                          navigateTo({ pathname: `/projects/flows/learn` })
                          dispatch(setProjectInfoKey(new Date().getTime()))
                        }}
                      />
                    }
                  </div>
                }
              </div>

              <div className="em-items bottom">
                <BottomNavigationItems
                  currentPath={currentPath}
                  checkUberDeployment={checkUberDeployment}
                  navigateTo={navigateTo}
                  viewAbout={handleClickViewAbout}
                  buildInfo={buildInfo}
                  userProjectPermissions={userProjectPermissions}
                />
              </div>
            </>
          </div>
        )}
    </>
  )
}
const mapStateToProps = state => ({
  api: state.api,
  isSubscriptionCheck: state.isSubscriptionCheck,
})

export default connect(mapStateToProps)(NewVerticalNavigation)

export const DatoinLogo = ({ curTheme }) => {
  return (
    <>
      <div className={'logo-datoin'}>
        {' '}
        <img
          style={{ filter: curTheme === 'light' ? 'none' : 'hue-rotate(var(--cardHue))' }}
          className="logo-datoin-img"
          src={require('../images/favicon.ico')}
        ></img>
      </div>
    </>
  )
}

export const Bar = ({ handleCollpase, curTheme }) => {
  return (
    <>
      <div onClick={handleCollpase} data-theme={curTheme} className="collapsibleIcon">
        <div id={'burger-menu'}>
          <i style={{ color: '#fff', fontSize: 17 }} class="fa fa-bars" aria-hidden="true"></i>
        </div>
      </div>
    </>
  )
}

const TopNavigationItems = ({
  dataset,
  activeItem,
  items,
  currentPath,
  checkUberDeployment,
  current_logged_user,
  navigateTo,
  totalapps,
  data,
  history,
  dispatch,
  currentAvailedPlan
}) => {
  return (
    <>
      {items && (
        <>
          <VerticalNavbarItem
            checkUberDeployment={checkUberDeployment}
            style={
              currentPath ===
                `/${current_logged_user.orgId}/${current_logged_user.spaceId}/projects/${current_logged_user.spaceId}`
                ? 'nav-item selected'
                : 'nav-item'
            }
            title={currentAvailedPlan.toUpperCase() === 'LEARNER' ? 'Current Module' : 'Active Project'}
            name={'home'}
            link={`/${current_logged_user.orgId}/${current_logged_user.spaceId}/projects/${current_logged_user.spaceId}`}
            index={0}
            external={false}
            navigateTo={e => {
              e.preventDefault()
              history.push(
                `/${current_logged_user.orgId}/${current_logged_user.spaceId}/projects/${current_logged_user.spaceId}`
              )
            }}
          />

          <VerticalNavbarItem
            checkUberDeployment={checkUberDeployment}
            style={currentPath === `/projects` ? 'nav-item selected allproject' : 'nav-item allproject'}
            title={currentAvailedPlan.toUpperCase() === 'LEARNER' ? 'Your Courses' : 'My Projects'}
            link="/projects"
            name={'projects'}
            index={1}
            external={false}
            navigateTo={e => {
              e.preventDefault()
              navigateTo('/projects')
              dispatch(setProjectInfoKey(new Date().getTime()))
            }}
          />
          {currentAvailedPlan.toUpperCase() !== 'LEARNER' &&
            items
              .filter(function (itemlink) {
                return itemlink && itemlink.name && itemlink.name !== 'studio'
              })
              .map((item, index) => {
                return (
                  <VerticalNavbarItem
                    currentPath={currentPath}
                    item={item}
                    checkUberDeployment={checkUberDeployment}
                    style={
                      item.external
                        ? currentPath === item.link || item['link'].includes(currentPath)
                          ? 'nav-item selected'
                          : 'nav-item '
                        : currentPath === item.link || currentPath.includes(item['link'])
                          ? 'nav-item selected'
                          : 'nav-item '
                    }
                    totalapps={totalapps}
                    link={item.link}
                    name={item.name}
                    title={item.title}
                    icon={item.icon}
                    initialActive={index == 0}
                    active={activeItem && item.name === activeItem.name}
                    data={data}
                    index={index}
                    dataset={dataset}
                    external={item.external}
                    navigateTo={event => {
                      event.preventDefault()
                      if (item.external) {
                        navigateTo('/' + item.name)
                      } else {
                        if (item.name === 'datasets' && dataset.currentFolderId !== undefined) {
                          navigateTo(
                            `/${current_logged_user.orgId}/${current_logged_user.spaceId}${item.link}/${dataset.currentFolderId}`,
                            { date_id: new Date().getTime() }
                          )
                        } else {
                          navigateTo(`/${current_logged_user.orgId}/${current_logged_user.spaceId}${item.link}`, {
                            date_id: new Date().getTime()
                          })
                        }
                      }
                    }}
                  />
                )
              })}
        </>
      )}
    </>
  )
}

const VerticalNavbarItem = ({
  currentPath,
  item,
  link,
  style,
  totalapps,
  data,
  navigateTo,
  external,
  title,
  name,
  active
}) => {
  return (
    <a className={style} title={title} active={active} href={link} onClick={e => navigateTo(e)}>
      {name === 'apps' ? (
        appsIcon()
      ) : name === 'datasets' ? (
        datasetsIcon()
      ) : name === 'emlyViz' ? (
        vizardIcon()
      ) : name === 'emlyNoteBook' ? (
        noteBookIcon()
      ) : name === 'home' ? (
        homeIcon()
      ) : name === 'projects' ? (
        projectsIcon()
      ) : name === 'learnFlows' ? (
        LearnFLowIcon()
      ) : name === 'buildFlows' ? (
        BuildFlowIcon()
      ) : (
        defaultIcon()
      )}

      <div className="name-case">
        {title && title === 'Datasets' ? 'DataLab' : title === 'My Apps' ? 'Agents' : title}
        {external && (
          <>
            {/* added count of myapps */}

            {item.name === 'apps' && currentPath.includes('/apps') && (
              <div className="count-total-apps">{totalapps}</div>
            )}
            {/* added count of appstore apps */}
            {item.name === 'appStore' && currentPath.includes('/app-store') && (
              <div className="count-total-apps">{data.pageInfo.total > 0 ? <>{data.pageInfo.total}</> : '0'}</div>
            )}
          </>
        )}
      </div>
    </a>
  )
}

const BottomNavigationItems = ({ ...props }) => {
  const viewAbout = () => {
    if (
      props.userProjectPermissions &&
      !props.userProjectPermissions.isLoading &&
      props.userProjectPermissions.debug_perm === true
    ) {
      props.viewAbout()
    }
  }

  return (
    <>
      <a
        className={`nav-item ${props.currentPath === '/organizations' && 'selected'}`}
        title={'Admin'}
        href={'/organizations'}
        onClick={e => {
          e.preventDefault()
          props.navigateTo({ pathname: '/organizations', state: 'AdminClick' })
        }}
      >
        <svg id="emly-icn" width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="28" height="28" rx="6" fill="var(--themeColor)" />
          <path
            d="M14.0002 10.875C13.3822 10.875 12.778 11.0583 12.2641 11.4017C11.7502 11.745 11.3496 12.2331 11.1131 12.8041C10.8766 13.3751 10.8147 14.0035 10.9353 14.6097C11.0558 15.2158 11.3535 15.7727 11.7905 16.2097C12.2275 16.6467 12.7844 16.9444 13.3906 17.065C13.9967 17.1855 14.6251 17.1236 15.1961 16.8871C15.7671 16.6506 16.2552 16.2501 16.5986 15.7362C16.9419 15.2223 17.1252 14.6181 17.1252 14C17.1227 13.172 16.7927 12.3785 16.2072 11.793C15.6217 11.2075 14.8283 10.8775 14.0002 10.875ZM20.7471 14C20.7455 14.292 20.7241 14.5836 20.683 14.8727L22.585 16.3617C22.6678 16.4301 22.7236 16.5257 22.7425 16.6315C22.7613 16.7373 22.7419 16.8463 22.6877 16.9391L20.8885 20.0453C20.8338 20.1373 20.7484 20.207 20.6474 20.2422C20.5464 20.2774 20.4362 20.2759 20.3362 20.2379L18.0998 19.3395C17.6342 19.698 17.1246 19.9956 16.5834 20.225L16.249 22.5992C16.2303 22.7056 16.1753 22.8021 16.0933 22.8724C16.0113 22.9426 15.9074 22.9822 15.7994 22.9844H12.201C12.095 22.9823 11.9928 22.9444 11.9112 22.8768C11.8295 22.8092 11.7732 22.7159 11.7514 22.6121L11.417 20.2379C10.8744 20.0112 10.3644 19.7131 9.90061 19.3516L7.66428 20.25C7.56431 20.288 7.45413 20.2896 7.35311 20.2545C7.25209 20.2193 7.16669 20.1497 7.11194 20.0578L5.31272 16.952C5.25856 16.8592 5.23916 16.7502 5.25798 16.6444C5.2768 16.5386 5.33262 16.443 5.41545 16.3746L7.31741 14.8855C7.27684 14.5921 7.25544 14.2963 7.25334 14C7.25497 13.708 7.27637 13.4164 7.31741 13.1273L5.41545 11.6383C5.33262 11.5699 5.2768 11.4743 5.25798 11.3685C5.23916 11.2627 5.25856 11.1537 5.31272 11.0609L7.11194 7.95469C7.16663 7.86273 7.252 7.79301 7.35303 7.75779C7.45406 7.72256 7.56427 7.72409 7.66428 7.76211L9.90061 8.66055C10.3663 8.30196 10.8759 8.00436 11.417 7.775L11.7514 5.40078C11.7701 5.29443 11.8252 5.19788 11.9072 5.12763C11.9892 5.05738 12.093 5.01779 12.201 5.01562H15.7994C15.9054 5.01769 16.0076 5.05562 16.0893 5.12323C16.1709 5.19084 16.2272 5.28414 16.249 5.38789L16.5834 7.76211C17.1267 7.98866 17.6374 8.28674 18.1018 8.64844L20.3362 7.75C20.4361 7.71195 20.5463 7.71036 20.6473 7.74551C20.7483 7.78066 20.8337 7.8503 20.8885 7.94219L22.6877 11.0484C22.7419 11.1412 22.7613 11.2502 22.7425 11.356C22.7236 11.4618 22.6678 11.5574 22.585 11.6258L20.683 13.1148C20.7236 13.4082 20.745 13.7039 20.7471 14Z"
            fill="white"
          />
        </svg>

        <div className="name-case">Admin</div>
      </a>
      {props.buildInfo &&
        !props.buildInfo.isLoading &&
        props.buildInfo.result &&
        <>
          <span className='ver-line'></span>
          <div className={`nav-item version`} title={'Version'} href={'/organizations'} onClick={() => viewAbout()}>
            <div className="ver-1">Version</div>
            <div className="ver-2">
              {props.buildInfo.result.Keystone &&
                props.buildInfo.result.Keystone.version
                ? props.buildInfo.result.Keystone.version.replaceAll('EMLY', '')
                : 'NA'
              }
            </div>
          </div>
        </>
      }
    </>
  )
}
